























































































































































































































































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import draggable from 'vuedraggable'
import questionApi from '@/api/question/index.ts'

@Component({
  components: {
    PicModal,
    draggable
  }
})
export default class EditQuestion extends AbpBase {
  form = {
    name: null,
    description: null,
    isActive: true,
    questions: []
  }

  ruleForm = {
    name: [{ required: true, message: '请输入问卷标题', trigger: 'blur' }],
    description: [
      { required: true, message: '请输入问卷说明', trigger: 'blur' }
    ]
  }

  alphabetList: any[] = []

  addQuestionForm = {
    title: null,
    type: 0,
    options: [
      {
        text: null,
        pictureUrl: null,
        allowCustom: false
      }
    ]
  }

  addQuestionRules = {
    title: [{ required: true, message: '请输入问题', trigger: 'blur' }]
  }

  selectIndex = -1
  relationIndex = -1
  showRelation = false

  // 关联规则
  addRelationRule = {
    // isSingle 0 选择全部 1 是单选
    // isChoose 0 没有选择 1 选择
    list: [{ options: [], index: null, isSingle: 1, isChoose: 1 }],
    // 1 且 0 或
    andOr: 1
  }

  // 可选择关联数组
  get relationList() {
    let list = []
    if (this.form.questions && this.form.questions.length > 0) {
      list = this.form.questions.filter(
        (item, index) => index < this.relationIndex && item.type != 2
      )
    }
    return list
  }

  validateRelationRule(rule, value, callback) {
    if (rule.item['index'] === null) {
      callback(new Error('请选择关联问题'))
    } else if (rule.item['options'].length <= 0) {
      callback(new Error('请选择选项'))
    } else {
      callback()
    }
  }

  created() {
    this.upperCaseChars()
    this.getQuestionnaire()
  }

  /**
   * 生成字母列表 A-Z
   */
  upperCaseChars() {
    //生成大写字母，A的Unicode值为65
    this.alphabetList = []
    for (var i = 65; i < 91; i++) {
      this.alphabetList.push(String.fromCharCode(i))
    }
  }

  /**
   * 获取问卷详情
   */
  getQuestionnaire() {
    let id = this.$route.query['id']
    if (id) {
      questionApi.getQuestionnaire(id.toString()).then(res => {
        if (res.data) {
          this.form = res.data
        }
      })
    }
  }

  /**
   * 问题拖拽
   */
  draggableChange(e) {
    this.judgeRelation()
  }

  /**
   * 判断问题是否有关联项
   * 如果有判断关联是否合理
   */
  judgeRelation() {
    let questions = JSON.parse(JSON.stringify(this.form.questions))
    questions.forEach((item, index) => {
      if (index == 0) {
        item['rule'] = null
      } else if (
        item['rule'] &&
        item['rule']['list'] &&
        item['rule']['list'].length > 0
      ) {
        item.rule.list.forEach((child, childIndex) => {
          let parent = questions[child.index]
          if (child.index >= index) {
            item.rule.list.splice(childIndex, 1)
          } else if (parent.type == 2) {
            item.rule.list.splice(childIndex, 1)
          } else if (child.options.length > parent.options.length) {
            item.rule.list.splice(childIndex, 1)
          } else {
            let newArr = []
            for (let i = 0; i < parent.options.length; i++) {
              for (let j = 0; j < child.options.length; j++) {
                if (child.options[j] === i) {
                  newArr.push(child.options[j])
                }
              }
            }
            if (child.options.sort().toString() != newArr.sort().toString()) {
              item.rule.list.splice(childIndex, 1)
            }
          }
        })
        if (item.rule.list.length <= 0) {
          item['rule'] = null
        }
      }
    })
    // 保证数据更新，页面实时刷新
    this.$set(this.form, 'questions', questions)
  }

  /**
   * 问题类型改变
   */
  typeChange(e) {
    if (e == 2) {
      // 类型为2 填空时选项数组只有一条
      this.addQuestionForm.options.splice(1)
    }
  }

  /**
   * 问题关联
   */
  relationFn(index) {
    this.relationIndex = index
    let item = this.form.questions[this.relationIndex]
    if (item['rule']) {
      this.addRelationRule = JSON.parse(JSON.stringify(item['rule']))
    }
    this.showRelation = true
  }

  /**
   * 添加问题关联项
   */
  addRelationFn() {
    this.addRelationRule.list.push({
      options: [],
      index: null,
      isSingle: 1,
      isChoose: 1
    })
  }

  /**
   * 删除单个问题关联项
   */
  deleteRelationFn(index) {
    this.addRelationRule.list.splice(index, 1)
  }

  /**
   * 清除所选问题的关联内容
   */
  clearRelationFn() {
    if (this.relationIndex >= 0) {
      this.form.questions[this.relationIndex]['rule'] = null
    }
    this.cancelRelationFn()
  }

  /**
   * 选择问题关联项
   */
  ruleIndexChange(e, index) {
    let isHave = this.addRelationRule.list.some((item, itemIndex) => {
      if (e === item['index'] && itemIndex != index) {
        setTimeout(() => {
          this.addRelationRule.list[index]['index'] = null
          this.addRelationRule.list[index]['options'] = []
        }, 10)
        return true
      }
    })

    if (isHave) {
      this.$Modal.error({
        title: '关联题目不能重复'
      })
    }
  }

  /**
   * 取消问题关联项
   */
  cancelRelationFn() {
    this.relationIndex = -1
    this.addRelationRule = {
      list: [{ options: [], index: null, isSingle: 1, isChoose: 1 }],
      andOr: 1
    }
    this.showRelation = false
  }

  /**
   * 保存问题关联
   */
  saveRelationFn() {
    let addRelationForm: any = this.$refs.addRelationForm
    addRelationForm.validate(valid => {
      if (valid) {
        if (this.relationIndex >= 0) {
          this.form.questions[this.relationIndex]['rule'] = JSON.parse(
            JSON.stringify(this.addRelationRule)
          )
        }
        this.cancelRelationFn()
      }
    })
  }

  /**
   * 添加选项
   */
  addOptionFn() {
    let max = 10
    if (this.addQuestionForm.options.length < max) {
      let obj = {
        text: null,
        pictureUrl: null,
        allowCustom: false
      }
      this.addQuestionForm.options.push(obj)
    } else {
      this.$Message.warning(`最多添加${max}个选项`)
    }
  }

  /**
   * 删除问题
   */
  remove(index) {
    if (this.form.questions.length > 1) {
      this.form.questions.splice(index, 1)
      this.judgeRelation()
    }
  }

  /**
   * 删除选项
   */
  clearFn(index) {
    if (this.addQuestionForm.options.length > 1) {
      this.addQuestionForm.options.splice(index, 1)
    }
  }

  picChange(e, index) {
    this.addQuestionForm.options[index]['pictureUrl'] = e[0].url
  }

  deleteImgFn(index) {
    this.addQuestionForm.options[index]['pictureUrl'] = null
  }

  /**
   * 编辑问题
   */
  edit(index) {
    this.selectIndex = index
    this.addQuestionForm = JSON.parse(
      JSON.stringify(this.form.questions[this.selectIndex])
    )
  }

  /**
   * 取消编辑
   */
  cancelFn() {
    this.addQuestionForm = {
      title: null,
      type: 0,
      options: [
        {
          text: null,
          pictureUrl: null,
          allowCustom: false
        }
      ]
    }

    this.selectIndex = -1
  }

  /**
   * 保存编辑
   */
  saveFn() {
    let addForm: any = this.$refs.addQuestionForm
    addForm.validate(valid => {
      if (valid) {
        if (this.selectIndex >= 0) {
          this.form.questions[this.selectIndex] = this.addQuestionForm
          this.judgeRelation()
        } else {
          this.form.questions.push(this.addQuestionForm)
        }
        this.cancelFn()
      } else {
        this.$Notice.error({ desc: '请输入必填项!' })
      }
    })
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate(valid => {
      if (valid) {
        if (this.form.questions.length <= 0) {
          this.$Modal.error({
            title: '请添加问题'
          })
        } else {
          this.judgeRelation()
          console.log(this.form)
          questionApi.createQuestionnaire(this.form).then(res => {
            this.$router.push({
              name: 'questionList'
            })
          })
        }
      }
    })
  }
}
